module.exports = __webpack_public_path__ + "static/media/2DGACM16.9b385963.jpg";